import { render, staticRenderFns } from "./KkmClose.vue?vue&type=template&id=2b456fed&"
import script from "./KkmClose.vue?vue&type=script&lang=js&"
export * from "./KkmClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports